module.exports = __webpack_public_path__ + "static/bgBannersLanding-d7be7c752100d56d4d586d44eb8a8665.mp4";